import { BiFolder, BiBuildingHouse } from 'react-icons/bi';
import { GrMapLocation } from 'react-icons/gr';
import { TbFolderPin } from 'react-icons/tb';
import { LuHouse } from 'react-icons/lu';

interface NavigationItem {
  to: string;
  icon?: React.ElementType;
  label: string;
}

export const getNavigationItems = (): NavigationItem[] => {
  const items: NavigationItem[] = [];

  items.push({
    to: '/',
    icon: LuHouse,
    label: 'home',
  });

  items.push({
    to: '/area-portfolios',
    icon: TbFolderPin,
    label: 'myAreaPortfolios',
  });

  items.push({
    to: '/area-report',
    icon: GrMapLocation,
    label: 'areaAnalysis',
  });

  items.push({
    to: '/portfolios',
    icon: BiFolder,
    label: 'myPortfolios',
  });

  items.push({
    to: '/properties',
    icon: BiBuildingHouse,
    label: 'propertyAnalysis',
  });

  return items;
};
